/**
 *
 */

import { useEffect } from "react";

export default function useOneOpenAccordion(
  containerSelector = ".psa-sidebar",
  detailsSelector = ".psa-acc"
) {
  useEffect(() => {
    const container = document.querySelector(containerSelector);
    if (!container) return;

    const items = Array.from(
      container.querySelectorAll<HTMLDetailsElement>(detailsSelector)
    );

    const onToggle = (e: Event) => {
      const current = e.currentTarget as HTMLDetailsElement;
      if (!current.open) return;

      for (const d of items) {
        if (d !== current && d.open) {
          d.open = false;
        }
      }
    };

    items.forEach((d) => d.addEventListener("toggle", onToggle));

    return () => {
      items.forEach((d) => d.removeEventListener("toggle", onToggle));
    };
  }, [containerSelector, detailsSelector]);
}
